import { groupBy } from 'utils/utils'

/**
 * Groups fields by object id
 */
export const groupFieldsByObjectId = (fields: FieldDto[]) => {
    return groupBy(fields, 'object_id')
}
